import type { EChartsOption } from "echarts";
import EChartBase from "./EChartBase";
import { chartPalette } from "./ChartTheme";

export type BubbleDatum = {
  label: string;
  x: number;
  y: number;
  size: number;
  tone?: string;
};

type Props = {
  data: BubbleDatum[];
  height?: number | string;
  xName?: string;
  yName?: string;
};

export default function BubbleChart({ data, height = 340, xName = "Risk", yName = "Return" }: Props) {
  const option: EChartsOption = {
    tooltip: {
      formatter: (p: any) => `${p.data.name}<br/>${xName}: ${p.data.value[0]}<br/>${yName}: ${p.data.value[1]}`,
    },
    grid: { left: 50, right: 30, top: 20, bottom: 45 },
    xAxis: { name: xName, type: "value" },
    yAxis: { name: yName, type: "value" },
    series: [
      {
        type: "scatter",
        symbolSize: (val: any) => Math.max(8, Math.sqrt(Number(val[2] || 1)) / 50),
        data: data.map((x) => ({
          name: x.label,
          value: [x.x, x.y, x.size],
          itemStyle: { color: chartPalette.blue },
        })),
      },
    ],
  };

  return <EChartBase option={option} height={height} empty={!data?.length} />;
}